module.exports = __webpack_public_path__ + "fonts/ProximaNovaACond-Black.466ad9d53c4c7561d7ce85b6d73dd93f.woff";